import { Component, Input, output } from '@angular/core';

import type {
  ActivitySubscriptionType,
  ActivitySubscriptionEvent,
  ActivitySubscriptions,
  ActivitySubscriptionUpdateData,
} from '@recruitee/activities-types';
import { TranslatePipe } from '@recruitee/i18n';

import { ActivitySubscriptionsTableRowComponent } from '../activity-subscriptions-table/activity-subscriptions-table-row/activity-subscriptions-table-row.component';
import { ActivitySubscriptionsTableComponent } from '../activity-subscriptions-table/activity-subscriptions-table.component';

@Component({
  selector: 'rt-activity-subscriptions-me',
  templateUrl: './activity-subscriptions-me.component.html',
  styleUrls: ['../activity-subscriptions.less'],
  imports: [
    ActivitySubscriptionsTableComponent,
    TranslatePipe,
    ActivitySubscriptionsTableRowComponent,
  ],
})
export class ActivitySubscriptionsMeComponent {
  @Input() public types: ActivitySubscriptionType[];
  @Input() public activitySubscriptions: ActivitySubscriptions;
  @Input() public hasRequisitions = false;
  @Input() public abilities = {
    viewRequisitions: false,
  };
  public changeEvents = output<ActivitySubscriptionUpdateData>();

  public assignmentEventsGroup: ActivitySubscriptionEvent[] = [
    'assignmentAdd',
    'assignmentRemove',
    'interviewEventRemove',
    'interviewEventChange',
    'interviewResultRequested',
    'requisitionAssignmentAdd',
    'requisitionAssignmentRemove',
    'candidateAccessReceived',
  ];
}
